// This file is designed to add extra functionalities to Plugin class

var PluginInfinityGettersMixin = {
  getSessionId: function () {
    return this.storage.getLocal('session')
  },

  getContext: function () {
    return this.storage.getSession('context')
  },

  getStoredData: function () {
    return this.storage.getLocal('data')
  },

  getPageName: function () {
    if (document && document.title) {
      return document.title
    }
  },

  getIsSessionExpired: function () {
    var now = new Date().getTime()
    return (this.infinity.getFirstActive() + this.sessionExpire < now) || !this.getSessionId()
  },

  getIsDataExpired: function () {
    var now = new Date().getTime()
    return (this.infinity.getFirstActive() + this.sessionExpire < now) || !this.getStoredData()
  }
}

module.exports = PluginInfinityGettersMixin
